import React from "react";
import InsightRows from "../components/InsightRows";
import TamperHeroSection from "../components/TamperHeroSection";
import TamperProofFAQS from "../components/tamperProofFAQS";
import TamperPricingSection from "../components/TamperPricingSection";
import TamperProofWorking from "../components/TamperProofWorking";
import DemoSection from "../components/DemoSection";
import TamperProofGraph from "../components/tamperProofGraph";
import TamperProofFooter from "../components/TamperProofFooter";
import TextCarosul from "../components/TextCarosul";

const TamperProof = () => {
  return (
    <>
      <TamperHeroSection />
      <InsightRows />
      <TamperProofGraph />
      <TamperProofWorking />
      <DemoSection />
      <TamperPricingSection />
      <TamperProofFAQS />
      <TextCarosul />
      <TamperProofFooter />
    </>
  );
};

export default TamperProof;
